import Breadcrumbs from "components/Common/Breadcrumb";
import React, { useCallback, useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container, FormGroup,
  Input,
  Row,
} from "reactstrap";
import {
  // StockAdjustment
  getStockAdjustments,
  addNewStockAdjustment,
  updateStockAdjustment,
  getStockAdjustmentById,
  deleteStockAdjustment,
  clearStockAdjustmentError,
  getConfirmStockAdjustment,
} from "store/actions";
import ConfirmDeleteModal from "components/Common/ConfirmDeleteModal";
import { toastMessage } from "helpers/utils";

import { debounce } from "lodash";
import StockAdjustmentTable from "containers/stock-adjustment/StockAdjustmentTable";
import ModalForm from "containers/stock-adjustment/ModalForm";
import StockAdjustmentConfirmModal from "containers/stock-adjustment/StockAdjustmentConfirmModal";
import WarehouseSelect from "../../containers/warehouse/WarehouseSelect";

const StockAdjustmentList = props => {
  const [id, setId] = useState(null);
  const [term, setTerm] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [modalEditIsOpen, setModalEditIsOpen] = useState(false);
  const [modalAddIsOpen, setModalAddIsOpen] = useState(false);
  const [modalConfirmDeleteIsOpen, setModalConfirmDeleteIsOpen] =
    useState(false);
  const [modalConfirmStock, setModalConfirmStock] = useState(false);
  const [ warehouses, setWarehouses ] = useState([])

  const {
    getStockAdjustments,
    addNewStockAdjustment,
    deleteStockAdjustment,
    updateStockAdjustment,
    clearStockAdjustmentError,
    getStockAdjustmentById,
    getConfirmStockAdjustment,
    message,
    items,
    item,
    loading,
    itemCount,
    pageCount,
    history,
  } = props;

  const debouncedFetchData = useCallback(
    debounce(term => {
      setTerm(term);
    }, 1000),
    []
  );

  useEffect(() => {
    getStockAdjustments({ 
      page, 
      pageSize, 
      term,
      warehouseIds: warehouses.map(warehouse => warehouse.value)
    });
  }, [page, pageSize, term, warehouses]);

  useEffect(() => {
    if (message) {
      toastMessage(message);
      clearStockAdjustmentError();
    }
  }, [message]);

  const handleUpdate = supplier => {
    updateStockAdjustment(supplier);
    setModalEditIsOpen(false);
  };

  const handleOnAddNew = () => {
    history.push(`/stock-adjustment/add-new`);
  };

  const handleSubmit = item => {
    addNewStockAdjustment(item);
    setModalAddIsOpen(false);
  };

  const handleConfirmDelete = id => {
    setId(id);
    setModalConfirmDeleteIsOpen(true);
  };

  const handleDelete = () => {
    deleteStockAdjustment(id);
    setModalConfirmDeleteIsOpen(false);
  };

  const handleOnDetail = id => {
    history.push(`/stock-adjustment/${id}`);
  };

  const handleConfirmStock = id => {
    setId(id);
    setModalConfirmStock(true);
  };

  const handleSubmitStockConfirmation = () => {
    getConfirmStockAdjustment({ stockAdjustmentId: id, type: "List" });
    setModalConfirmStock(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Stock Adjustment | CR TechSoft</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Stock Adjustment"
            breadcrumbItem="Stock Adjustment List"
          />
          <Row>
            <Col md={12}>
              <Card className="mb-1 rounded-3">
                <CardHeader className="bg-transparent border pb-0 pt-3">
                  <Row className="g-1">
                    <Col md={2}>
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <Input
                            type="text"
                            placeholder="Quick Search ..."
                            onChange={e => {
                              debouncedFetchData(e.target.value);
                            }}
                          ></Input>
                          <i className="fas fa-search search-icon" />
                        </div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <WarehouseSelect
                            name="warehouses"
                            placeholder={ "Warehouse" }
                            value={ warehouses }
                            onChange={ option => {
                              setPage(1);
                              setWarehouses(option)
                            } }
                            isMulti={ true }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={2}></Col>
                    <Col md={4}>
                      <div className="text-sm-end">
                        <Button
                          type="button"
                          color="primary"
                          className="me-1"
                          onClick={handleOnAddNew}
                        >
                          <i className="fas fa-plus" /> Add New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <Collapse isOpen={false}>
                  <CardBody className="pb-1"></CardBody>
                </Collapse>
              </Card>
            </Col>
            <Col md={12}>
              {items && (
                <StockAdjustmentTable
                  items={items}
                  itemCount={itemCount}
                  page={page}
                  totalPage={pageCount}
                  loading={loading}
                  defaultPageSize={pageSize}
                  onDetails={handleOnDetail}
                  onConfirm={handleConfirmStock}
                  onConfirmDelete={handleConfirmDelete}
                  onChangePage={page => setPage(page)}
                  onPageSizeChange={pageSize => {
                    setPage(1);
                    setPageSize(pageSize);
                  }}
                />
              )}
              {item && (
                <ModalForm
                  title={"Edit Stock Adjustment"}
                  item={item}
                  isOpen={modalEditIsOpen}
                  toggle={() => setModalEditIsOpen(!modalEditIsOpen)}
                  onSubmit={handleUpdate}
                />
              )}
              <ModalForm
                title={"Add Stock Adjustment"}
                isOpen={modalAddIsOpen}
                toggle={() => setModalAddIsOpen(!modalAddIsOpen)}
                onSubmit={handleSubmit}
              />
              <ConfirmDeleteModal
                title="Confirm Delete"
                isOpen={modalConfirmDeleteIsOpen}
                toggle={() =>
                  setModalConfirmDeleteIsOpen(!modalConfirmDeleteIsOpen)
                }
                onSubmit={handleDelete}
              />
              <StockAdjustmentConfirmModal
                title="Confirm item to adjust stock"
                isOpen={modalConfirmStock}
                toggle={() => setModalConfirmStock(!modalConfirmStock)}
                onSubmit={handleSubmitStockConfirmation}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

StockAdjustmentList.propTypes = {
  items: PropTypes.array,
  item: PropTypes.object,
  loading: PropTypes.bool,
  message: PropTypes.object,
  error: PropTypes.string,
  itemCount: PropTypes.number,
  pageCount: PropTypes.number,
  history: PropTypes.object,

  getStockAdjustments: PropTypes.func,
  addNewStockAdjustment: PropTypes.func,
  updateStockAdjustment: PropTypes.func,
  getStockAdjustmentById: PropTypes.func,
  deleteStockAdjustment: PropTypes.func,
  clearStockAdjustmentError: PropTypes.func,
  getConfirmStockAdjustment: PropTypes.func,
};

const mapStateToProps = ({ stockAdjustment }) => {
  return stockAdjustment;
};

export default withRouter(
  connect(mapStateToProps, {
    getStockAdjustments,
    addNewStockAdjustment,
    updateStockAdjustment,
    getStockAdjustmentById,
    deleteStockAdjustment,
    clearStockAdjustmentError,
    getConfirmStockAdjustment,
  })(StockAdjustmentList)
);
